module.exports = __webpack_public_path__ + "img/26_4.ea0056a6.png";